export default "__VITE_ASSET__DnJX1M9J__"